import { useState, useEffect } from 'react'
import cn from 'clsx'

const CreateOrgWidget = ({
    className,
    newOrgName,
    setNewOrgName,
    checkOrgExists,
    onCreateOrgClick,
}) => {
    
    const [orgExists, setOrgExists] = useState(false)
    
    useEffect(() => {
        
        const t = setTimeout(() => {
            setOrgExists(false)
            if (!newOrgName.length) return
            checkOrgExists(newOrgName)
                .then(exists => setOrgExists(exists))
        }, 500)
        
        return () => clearTimeout(t)
        
    }, [newOrgName])
    
    return (
        
        <div className={cn('CreateOrgWidget card', className)}>
            <div>
                <h3 className="text-xl">Create New Organization</h3>
                <div className="flex items-center justify-between mt-2 form-group">
                    <label className="form-control w-full max-w-xs relative">
                        <input
                            className={cn('input input-bordered', {
                                'input-error': orgExists,
                            })}
                            type="text"
                            value={newOrgName}
                            placeholder="ACME Corp."
                            autoComplete="off"
                            onChange={e => setNewOrgName(e.target.value)} />
                        {orgExists && <div className="label absolute -bottom-7">
                            <span className="label-text-alt text-error">Organization already exists</span>
                        </div>
                        }
                    </label>
                    
                    <button
                        className="ml-3 btn btn-primary"
                        disabled={!newOrgName || orgExists}
                        title={orgExists ? 'Organization already exists' : ''}
                        onClick={onCreateOrgClick}>
                        Create Organization
                    </button>
                </div>
            </div>
        </div>
        
    )
    
}

export default CreateOrgWidget
